import { ItemEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemEds/ItemEds";
import { ItemStock } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStock/ItemStock";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import styles from "./item-stock-and-eds.module.css";

interface ItemStockAndEDSProps {
  itemNo: string;
  itemType: string;
  itemStock?: ItemStockInfo;
  disableItemStockQuery?: boolean;
}

export const ItemStockAndEds = ({
  itemNo,
  itemType,
  itemStock,
  disableItemStockQuery,
}: ItemStockAndEDSProps) => (
  <div className={styles["item-stock-eds-container"]}>
    <ItemStock
      itemNo={itemNo}
      itemType={itemType}
      stockInfo={itemStock}
      disableItemStockQuery={disableItemStockQuery}
    />
    <ItemEds itemNo={itemNo} />
  </div>
);
